import { render, staticRenderFns } from "./shopping.vue?vue&type=template&id=d637fda8&scoped=true"
import script from "./shopping.vue?vue&type=script&lang=ts"
export * from "./shopping.vue?vue&type=script&lang=ts"
import style0 from "./shopping.vue?vue&type=style&index=0&id=d637fda8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d637fda8",
  null
  
)

export default component.exports